window.drawLotteryAPI = {
    model: {
        showDrawLottery: false,
        showMiniDrawLottery: false,
        eventId: '',
        isLuck: -1,
        status: 0,
        name: '',
        desc: '',
    },
    redPacketId: '', // 红包雨抽奖ID
    // 获取抽奖信息
    getLuckInfo: function (callback) {
        if (common.getCookie('OCSESSID')){
            var ocsession = common.getCookie('OCSESSID');
            ocsession = ocsession.replace('\"',"");
            var _this = this;
            $.get('/index.php?route=api/luck_draw/getLuckInfo&api_token=' + ocsession, function (res) {
                // _this.model.eventId = res.data.info.eventId;
                // _this.model.name = res.data.info.name;
                // _this.model.desc = res.data.info.desc;
                // _this.model.isLuck = res.data.isLuck;
                // _this.model.status  = res.data.status;

                if (res.code == 0) {
                    if (res.data.red_packet) {
                        _this.redPacketId = res.data.red_packet.info.eventId;
                    }
                }

                // if (res.data.status == 1 && !res.data.isLuck && common.getCookie('showDrawLottery')){
                //     // 活动开启  &&  未抽过奖  && 不是第一次进来
                //     _this.model.showMiniDrawLottery = true; // 悬浮的红包入口
                // }else if (res.data.status == 1 && !res.data.isLuck && !common.getCookie('showDrawLottery')){
                //     // 活动开启  &&  未抽过奖  && 第一次进来
                //     _this.model.showDrawLottery = true; //大弹窗
                // }
                if (callback && typeof callback == "function"){
                    callback(res.data);
                }
            })
        }
    },

    luckDraw: function(callback){
        if (common.getCookie('OCSESSID') && common.isLogin()) {
            var ocsession = common.getCookie('OCSESSID');
            ocsession = ocsession.replace('\"', "");
            this.setRedPackCookie();
            common.postJson(solution_host + '/api/lucky/draw', {
                eventId: this.redPacketId
            },function (res) {
                if (res.errCode == 40000){
                    // alert(res.msg);
                    common.loginOut();
                    return;
                }
                if (callback && typeof callback == "function"){
                    callback(res.data);
                }
            }, true)
        }else{
            common.gotoLogin();
        }
    },
    // 设置cookie
    setRedPackCookie: function () {
        common.setCookie('showDrawLottery',1,1);
    }

}
